module.exports = __webpack_public_path__ + "media/images/lb/311-f2be5eb86b71ca5a7ed81636ea132bfb.svg";